import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { Toaster } from 'react-hot-toast';
import { AuthProvider } from './hooks/useAuth';
import ProtectedRoute from './components/auth/ProtectedRoute';
import LoginPage from './components/auth/LoginPage';
import ForgotPasswordContactPage from './components/auth/ForgotPasswordContactPage';
import ForgotPasswordOtpPage from './components/auth/ForgotPasswordOtpPage';
import ForgotPasswordResetPage from './components/auth/ForgotPasswordResetPage';
import CounterDepositsLedgerPage from './pages/cashTransactions/CounterDepositsLedgerPage';
import CounterDepositDetailPage from './pages/cashTransactions/CounterDepositDetailPage';
import CounterRedemptionsLedgerPage from './pages/cashTransactions/CounterRedemptionsLedgerPage';
import CounterRedemptionDetailPage from './pages/cashTransactions/CounterRedemptionDetailPage';
import DashboardPage from './pages/DashboardPage';
import HomePage from './pages/HomePage';
import PlayersPage from './pages/PlayersPage';
import PlayerDetailPage from './pages/PlayerDetailPage';
import TransactionsPage from './pages/TransactionsPage';
import OnlineBalanceTransactionsPage from './pages/OnlineBalanceTransactionsPage';
import TransferToPlayerPage from './pages/TransferToPlayerPage';
import SendPlayerPopupPage from './pages/SendPlayerPopupPage';
import SendBroadcastPage from './pages/SendBroadcastPage';
import MessagesComposePage from './pages/MessagesComposePage';
import MessagesHistoryPage from './pages/MessagesHistoryPage';
import ContactAdminPage from './pages/ContactAdminPage';
import ContactAdminTicketPage from './pages/ContactAdminTicketPage';
import MessagesCampaignDetailPage from './pages/MessagesCampaignDetailPage';
import SettingsPage from './pages/SettingsPage';
import KioskDomainPage from './pages/KioskDomainPage';
import CashiersPage from './pages/CashiersPage';
import CashierDetailPage from './pages/CashierDetailPage';
import ShiftsPage from './pages/ShiftsPage';
import ShiftFormPage from './pages/ShiftFormPage';
import ShiftDetailPage from './pages/ShiftDetailPage';
import CashierDevicesPage from './pages/CashierDevicesPage';
import CashierExceptionsPage from './pages/CashierExceptionsPage';
import RedemptionApprovalsPage from './pages/RedemptionApprovalsPage';
import ReconciliationPage from './pages/ReconciliationPage';
import ShiftReportsPage from './pages/ShiftReportsPage';
import FraudIndicatorsPage from './pages/FraudIndicatorsPage';
import ProviderFeesPage from './pages/ProviderFeesPage';
import DepositBonusPage from './pages/DepositBonusPage';
import WithdrawalsApprovalPage from './pages/WithdrawalsApprovalPage';
import GameWalletsOverviewPage from './pages/gameWallets/GameWalletsOverviewPage';
import GameWalletProviderDetailPage from './pages/gameWallets/GameWalletProviderDetailPage';
import {
  ShopPaymentCancelledPage,
  ShopPaymentErrorPage,
  ShopPaymentSuccessPage,
} from './pages/ShopPaymentReturnPage';

export default function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/login" element={<LoginPage />} />
          <Route path="/forgot-password" element={<ForgotPasswordContactPage />} />
          <Route path="/forgot-password/otp" element={<ForgotPasswordOtpPage />} />
          <Route path="/forgot-password/reset" element={<ForgotPasswordResetPage />} />
          <Route
            path="/"
            element={(
              <ProtectedRoute>
                <HomePage />
              </ProtectedRoute>
            )}
          />
          <Route
            path="/dashboard"
            element={(
              <ProtectedRoute>
                <DashboardPage />
              </ProtectedRoute>
            )}
          />
          <Route
            path="/players/:playerId"
            element={(
              <ProtectedRoute>
                <PlayerDetailPage />
              </ProtectedRoute>
            )}
          />
          <Route
            path="/players"
            element={(
              <ProtectedRoute>
                <PlayersPage />
              </ProtectedRoute>
            )}
          />
          <Route
            path="/game-wallets"
            element={(
              <ProtectedRoute>
                <GameWalletsOverviewPage />
              </ProtectedRoute>
            )}
          />
          <Route
            path="/game-wallets/:providerId"
            element={(
              <ProtectedRoute>
                <GameWalletProviderDetailPage />
              </ProtectedRoute>
            )}
          />
          <Route
            path="/cashiers"
            element={(
              <ProtectedRoute>
                <CashiersPage />
              </ProtectedRoute>
            )}
          />
          <Route
            path="/cashiers/:cashierId"
            element={(
              <ProtectedRoute>
                <CashierDetailPage />
              </ProtectedRoute>
            )}
          />
          <Route
            path="/shifts/new"
            element={(
              <ProtectedRoute>
                <ShiftFormPage />
              </ProtectedRoute>
            )}
          />
          <Route
            path="/shifts/:shiftId"
            element={(
              <ProtectedRoute>
                <ShiftDetailPage />
              </ProtectedRoute>
            )}
          />
          <Route
            path="/shifts"
            element={(
              <ProtectedRoute>
                <ShiftsPage />
              </ProtectedRoute>
            )}
          />
          <Route
            path="/cashier-devices"
            element={(
              <ProtectedRoute>
                <CashierDevicesPage />
              </ProtectedRoute>
            )}
          />
          <Route
            path="/cashier-exceptions"
            element={(
              <ProtectedRoute>
                <CashierExceptionsPage />
              </ProtectedRoute>
            )}
          />
          <Route
            path="/redemption-approvals"
            element={(
              <ProtectedRoute>
                <RedemptionApprovalsPage />
              </ProtectedRoute>
            )}
          />
          <Route
            path="/shift-reports"
            element={(
              <ProtectedRoute>
                <ShiftReportsPage />
              </ProtectedRoute>
            )}
          />
          <Route
            path="/reconciliation/:shiftId"
            element={(
              <ProtectedRoute>
                <ReconciliationPage />
              </ProtectedRoute>
            )}
          />
          <Route
            path="/fraud-indicators"
            element={(
              <ProtectedRoute>
                <FraudIndicatorsPage />
              </ProtectedRoute>
            )}
          />
          <Route
            path="/popups/send"
            element={(
              <ProtectedRoute>
                <SendPlayerPopupPage />
              </ProtectedRoute>
            )}
          />
          <Route
            path="/broadcasts/send"
            element={(
              <ProtectedRoute>
                <SendBroadcastPage />
              </ProtectedRoute>
            )}
          />
          <Route
            path="/messages"
            element={(
              <ProtectedRoute>
                <Navigate to="/messages/compose" replace />
              </ProtectedRoute>
            )}
          />
          <Route
            path="/contact-admin"
            element={(
              <ProtectedRoute>
                <ContactAdminPage />
              </ProtectedRoute>
            )}
          />
          <Route
            path="/contact-admin/:ticketNumber"
            element={(
              <ProtectedRoute>
                <ContactAdminTicketPage />
              </ProtectedRoute>
            )}
          />
          <Route
            path="/messages/compose"
            element={(
              <ProtectedRoute>
                <MessagesComposePage />
              </ProtectedRoute>
            )}
          />
          <Route
            path="/messages/history"
            element={(
              <ProtectedRoute>
                <MessagesHistoryPage />
              </ProtectedRoute>
            )}
          />
          <Route
            path="/messages/:campaignId"
            element={(
              <ProtectedRoute>
                <MessagesCampaignDetailPage />
              </ProtectedRoute>
            )}
          />
          <Route
            path="/cash-settlement/deposits/:id"
            element={(
              <ProtectedRoute>
                <CounterDepositDetailPage />
              </ProtectedRoute>
            )}
          />
          <Route
            path="/cash-settlement/deposits"
            element={(
              <ProtectedRoute>
                <CounterDepositsLedgerPage />
              </ProtectedRoute>
            )}
          />
          <Route
            path="/cash-settlement/redemptions/:id"
            element={(
              <ProtectedRoute>
                <CounterRedemptionDetailPage />
              </ProtectedRoute>
            )}
          />
          <Route
            path="/cash-settlement/redemptions"
            element={(
              <ProtectedRoute>
                <CounterRedemptionsLedgerPage />
              </ProtectedRoute>
            )}
          />
          <Route
            path="/transactions"
            element={(
              <ProtectedRoute>
                <TransactionsPage />
              </ProtectedRoute>
            )}
          />
          <Route
            path="/money"
            element={(
              <ProtectedRoute>
                <Navigate to="/transactions" replace />
              </ProtectedRoute>
            )}
          />
          <Route
            path="/online-transactions"
            element={(
              <ProtectedRoute>
                <OnlineBalanceTransactionsPage />
              </ProtectedRoute>
            )}
          />
          <Route
            path="/deposit-bonus/new"
            element={(
              <ProtectedRoute>
                <DepositBonusPage />
              </ProtectedRoute>
            )}
          />
          <Route
            path="/deposit-bonus/:campaignId"
            element={(
              <ProtectedRoute>
                <DepositBonusPage />
              </ProtectedRoute>
            )}
          />
          <Route
            path="/deposit-bonus"
            element={(
              <ProtectedRoute>
                <DepositBonusPage />
              </ProtectedRoute>
            )}
          />
          <Route
            path="/provider-fees"
            element={(
              <ProtectedRoute>
                <ProviderFeesPage />
              </ProtectedRoute>
            )}
          />
          <Route
            path="/withdrawals"
            element={(
              <ProtectedRoute>
                <WithdrawalsApprovalPage />
              </ProtectedRoute>
            )}
          />
          <Route path="/purchase" element={<Navigate to="/" replace />} />
          <Route
            path="/settings"
            element={(
              <ProtectedRoute>
                <SettingsPage />
              </ProtectedRoute>
            )}
          />
          <Route
            path="/kiosk-domain"
            element={(
              <ProtectedRoute>
                <KioskDomainPage />
              </ProtectedRoute>
            )}
          />
          <Route
            path="/transfer"
            element={(
              <ProtectedRoute>
                <Navigate to="/players" replace />
              </ProtectedRoute>
            )}
          />
          <Route
            path="/transfer/legacy"
            element={(
              <ProtectedRoute>
                <TransferToPlayerPage />
              </ProtectedRoute>
            )}
          />
          <Route
            path="/payment/success"
            element={(
              <ProtectedRoute>
                <ShopPaymentSuccessPage />
              </ProtectedRoute>
            )}
          />
          <Route
            path="/payment/cancelled"
            element={(
              <ProtectedRoute>
                <ShopPaymentCancelledPage />
              </ProtectedRoute>
            )}
          />
          <Route
            path="/payment/error"
            element={(
              <ProtectedRoute>
                <ShopPaymentErrorPage />
              </ProtectedRoute>
            )}
          />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
        <Toaster position="top-right" />
      </BrowserRouter>
    </AuthProvider>
  );
}
